import { IApiService } from 'web_core_library';
import { TGetSubscriptionResponse, TSubscriptionID } from './types';

export function createManagementService() {
  let ApiService: IApiService;
  const getSubscriptions = () => {
    return ApiService.action<TGetSubscriptionResponse>('users_subscriptions_v2', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
      },
    });
  };

  const terminateSubscription = (subscriptionId: TSubscriptionID, terminate = true) => {
    const data = terminate ? { end_of_period: 0 } : undefined;
    return ApiService.action('admin_web_subscriptions_v2', {
      method: 'post',
      urlParams: {
        userId: ApiService.getUserId(),
        subscriptionId,
      },
      data,
    });
  };

  const reactivateUserSubscription = (subscriptionId: TSubscriptionID) => {
    return ApiService.action('admin_web_subscriptions_restart_v2', {
      method: 'put',
      urlParams: {
        userId: ApiService.getUserId(),
        subscriptionId,
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getSubscriptions,
    terminateSubscription,
    reactivateUserSubscription,
  };
  return service;
}

const ManagementService = createManagementService();
export default ManagementService;
